"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GalleriesController", {
    enumerable: true,
    get: function() {
        return GalleriesController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _galleriesservice = require("~/services/galleries.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let GalleriesController = class GalleriesController {
    async galleryViewGet(context, galleryViewId) {
        return await this.galleriesService.galleryViewGet(context, {
            galleryViewId
        });
    }
    async galleryViewCreate(context, tableId, body, req) {
        return await this.galleriesService.galleryViewCreate(context, {
            gallery: body,
            // todo: sanitize
            tableId,
            req,
            user: req.user
        });
    }
    async galleryViewUpdate(context, galleryViewId, body, req) {
        return await this.galleriesService.galleryViewUpdate(context, {
            galleryViewId,
            gallery: body,
            req
        });
    }
    constructor(galleriesService){
        this.galleriesService = galleriesService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/galleries/:galleryViewId',
        '/api/v2/meta/galleries/:galleryViewId'
    ]),
    (0, _extractidsmiddleware.Acl)('galleryViewGet'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('galleryViewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], GalleriesController.prototype, "galleryViewGet", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/tables/:tableId/galleries',
        '/api/v2/meta/tables/:tableId/galleries'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('galleryViewCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ViewCreateReqType === "undefined" ? Object : _nocodbsdk.ViewCreateReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], GalleriesController.prototype, "galleryViewCreate", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/galleries/:galleryViewId',
        '/api/v2/meta/galleries/:galleryViewId'
    ]),
    (0, _extractidsmiddleware.Acl)('galleryViewUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('galleryViewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.GalleryUpdateReqType === "undefined" ? Object : _nocodbsdk.GalleryUpdateReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], GalleriesController.prototype, "galleryViewUpdate", null);
GalleriesController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _galleriesservice.GalleriesService === "undefined" ? Object : _galleriesservice.GalleriesService
    ])
], GalleriesController);
